module.exports = __webpack_public_path__ + "d23cc62b.svg";